/* eslint-disable max-lines-per-function */
import request from '../assets/scripts/request';
import { getInnerText, getLangText } from '../assets/scripts/utils';
const {
    common: {
        env: { isPreRender }
    }
} = require('@futuweb/fego-render');
const { useUser } = require('@fegobull/webapi').use;
const { isLogin, uid } = useUser();
const commonApiRequest = request.bindCommonApi('question');
const getQuestionProfile = async (data) => {
    return await commonApiRequest.get('get-question-profile', data);
};

const AUTH_MODE = {
    NEED_AUTH: 1,
    NO_AUTH: 0
};

// 处理问卷数据
import { reactive, ref, onBeforeMount } from 'vue-demi';
export default function useQuestionData(props) {
    // 暂时
    const baseData = reactive({
        title: '',
        desc: ''
    });
    const questions = ref([]);
    const questionStatus = ref();
    const userAnswer = ref();
    const authMode = ref(AUTH_MODE.NEED_AUTH);

    const getQuestion = () => {
        const { act_sign, question_sign } = props;
        question_sign &&
            getQuestionProfile({
                act_sign,
                question_sign
            }).then((res) => {
                const { answer, status, templateContent, authMode: resAuthMode } = res;
                baseData.title = getLangText(templateContent, 'title', props.lang);
                baseData.desc = getInnerText(getLangText(templateContent, 'info', props.lang));
                questions.value = templateContent.qa;
                questionStatus.value = status;
                userAnswer.value = isLogin && uid ? answer : [];
                authMode.value = Number(resAuthMode);
            });
    };

    !isPreRender && onBeforeMount(getQuestion);

    return {
        baseData,
        questions,
        questionStatus,
        userAnswer,
        authMode,
        getQuestion
    };
}
